import { combineReducers } from "redux";
import { onStart, language } from "./onStart";


export default combineReducers({
    onStart, language
});